import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=288b4322&scoped=true"
import script from "./Weekly.vue?vue&type=script&lang=js"
export * from "./Weekly.vue?vue&type=script&lang=js"
import style0 from "./Weekly.vue?vue&type=style&index=0&id=288b4322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b4322",
  null
  
)

export default component.exports